import { render } from "./CRMAgentsView.vue?vue&type=template&id=28dc05e5&scoped=true"
import script from "./CRMAgentsView.vue?vue&type=script&lang=js"
export * from "./CRMAgentsView.vue?vue&type=script&lang=js"

import "./CRMAgentsView.vue?vue&type=style&index=0&id=28dc05e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dc05e5"]])

export default __exports__